import { ArrowForward, InfoOutlined } from '@mui/icons-material'
import { Alert, Box, Button, Container, Stack, Typography, useTheme } from '@mui/material'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'
import { CustomTextField } from '../../../components/CustomTextField'
import { AppDispatch } from '../../../store'
import { VerificationActions, VerificationSelector } from '../../../store/Verification'
import { useSnackbar } from '../../../hooks/snackbar/useSnackbar'

export const VerifyEmail = () => {
  const [emailError, setEmailError] = useState('')
  const theme = useTheme()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const location = useLocation()
  const { showSuccess, showError } = useSnackbar()

  const { requestLoading, inputEmail: email } = useSelector(VerificationSelector.getVerificationState)

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newEmail = e.target.value
    dispatch(VerificationActions.setInputEmail(newEmail))
  }

  const handleSubmit = async () => {
    const normalizedEmail = email.trim().toLowerCase()
    if (!validateEmail(normalizedEmail)) {
      setEmailError('Please enter a valid email address')
      return
    }
    dispatch(VerificationActions.setInputEmail(normalizedEmail))
    const resultAction: any = await dispatch(VerificationActions.sendOtpAsync(normalizedEmail))
    if (VerificationActions.sendOtpAsync.fulfilled.match(resultAction)) {
      if (resultAction.payload.success) {

        showSuccess(resultAction.payload.message)

        navigate('/verify/otp', {state: location.state})
      }
    } else {
      showError(resultAction.payload.message || 'SERVER_ERROR')
    }
  }

  return (
    <Box
      sx={{
        py: 3,
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Stack alignItems="center" spacing={3.5} sx={{ maxWidth: '450px', backgroundColor: theme.palette.background.paper, p:2, borderRadius: theme.shape.borderRadius }}>
            <Stack alignItems="center">
              <Typography
                variant="h2"
                textAlign={'center'}
              >
                Let's get started!
              </Typography>

              <Typography variant="body1">
                Let's verify your email to get your test results
              </Typography>
            </Stack>

            <Alert severity="blue" icon={<InfoOutlined />} variant="filled">
              {' '}
              Use the same email address you provided when ordering your test kit
            </Alert>
            <CustomTextField
              label="Your email address"
              name="email"
              value={email}
              onChange={handleEmailChange}
              fullWidth
              placeholder="john.doe@gmail.com"
              required
              error={!!emailError}
              helperText={emailError}
            />

            <Button
              variant="contained"
              fullWidth
              size="large"
              sx={{ py: 2 }}
              endIcon={<ArrowForward />}
              onClick={handleSubmit}
              disabled={!email || requestLoading}
            >
              {requestLoading ? 'Sending...' : 'Send Verification code'}
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  )
}
